import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getActivitytypeIcon',
  standalone: true,
})
export class GetActivitytypeIconPipe implements PipeTransform {
  transform(activitytypeId: number | null | undefined): string {
    switch (activitytypeId) {
      case 2:
        return 'mail';
      case 3:
        return 'handshake';
      case 4:
        return 'local_post_office';
      case 5:
        return 'calendar_month';
      default: {
        return 'headset_mic';
      }
    }
  }
}
